<template>
  <div class="alert-modal">
    <modal :name="name" :title="title">
      <p v-if="hasSlot"><slot /></p>
      <sh-button color="primary" type="button" @click="onDismiss">{{ alert }}</sh-button>
    </modal>
  </div>
</template>

<script>

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    alert: {
      type: String,
      required: true
    }
  },
  computed: {
    hasSlot () {
      return Boolean(this.$slots.default)
    }
  },
  methods: {
    onDismiss () {
      this.$emit('dismiss')
    }
  }
}
</script>

<style lang="scss">

div.alert-modal {
  .modal-inner {
    text-align: center;
  }

  h2 {
    @include title-med;
    @include deprecated-f-color-dark;
  }

  p {
    margin: $d-med 0 0;
    @include body-lrg;
  }

  button {
    @include label-xx-sml;
    margin-top: $d-med-small;
    padding: $d-xx-small $d-large;
    max-width: 150px;
    align-self: center;
  }
}
</style>
